// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledScrollbar } from "@rc/App/SharedStyles/sharedStyles";
import Help from "@rc/XDL/Icons/Help";
import { xBaseTheme } from "@rc/XDL/types";
import { color } from "@rc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            tooltipWrapper: css`
                line-height: 0;
            `,
            tooltipContainer: css`
                padding: 18px 20px 17px 16px;
                font-size: 13px;
                line-height: 18px;
                max-width: 300px;
                color: ${color("text.main")};
                background-color: ${color("common.ui8")};
                border: 1px solid ${color("common.ui3")};
                text-align: left;
                border-radius: 6px;
                min-width: 140px;
                box-shadow: none;

                &[data-placement^="top"] > .tippy-arrow {
                    bottom: -13px;
                    &:before {
                        transform: rotate(45deg);
                    }
                }

                &[data-placement^="bottom"] > .tippy-arrow {
                    top: -13px;
                    &:before {
                        transform: rotate(-135deg);
                    }
                }

                &[data-placement^="left"] > .tippy-arrow {
                    right: -13px;
                    &:before {
                        transform: rotate(-45deg);
                    }
                }

                &[data-placement^="right"] > .tippy-arrow {
                    left: -13px;
                    &:before {
                        transform: rotate(135deg);
                    }
                }

                .tippy-arrow,
                .tippy-arrow::before {
                    position: absolute;
                    width: 27px;
                    height: 27px;
                    z-index: 1;
                    box-shadow: none;
                }

                .tippy-arrow::before {
                    content: "";
                    background: ${color("common.ui8")};
                    border-color: ${color("common.ui3")};
                    border-style: solid;
                    border-width: 0 1px 1px 0;
                }

                ${styledScrollbar(2)}
            `,
            tooltipBody: css`
                display: flex;
                flex-direction: column;
                flex: 0 0 auto;
            `,
            tooltipClickable: css`
                margin-left: 5px;
                margin-right: 5px;
            `,
        },
        iconProps: {
            src: Help,
            size: 16,
            color: "secondary",
            css: css``,
        },
        typographyProps: {
            size: 14,
            lineHeight: "22px",
            css: css`
                letter-spacing: 0;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
        titleTypographyProps: {
            size: 16,
            lineHeight: "24px",
            css: css`
                letter-spacing: 0;
                margin-bottom: 5px;
                font-weight: 600;
                color: ${color("common.ui10")};
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    },
} as xBaseTheme["tooltip"];
